import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserSeekAndFindGame from 'src/games/SeekAndFindGame/Main';

interface SeekAndFindGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class SeekAndFindGame extends React.Component<SeekAndFindGameProps> {
    constructor(props: SeekAndFindGameProps) {
        super(props);
        bindAllOfThis(this, SeekAndFindGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserSeekAndFindGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default SeekAndFindGame;



// WEBPACK FOOTER //
// ./src/pages/game/SeekAndFindGame.tsx